/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { getNoticeList } from "../../apis/boards";
import Badge from "../../components/Badge";
import { ColCard } from "../../components/ContentLayout";
import CardList from "../../components/List/CardList";
import { convertHexToRGBA, getColor } from "../../utils/color";
import { dateToViewFormat } from "../../utils/date";
import { comma } from "../../utils/number";
import { getParams } from "../../utils/params";
import { classnames } from "../../utils/text";
import { getDay } from "../../utils/date";
import useForm from "../../hooks/useForm";
import { cloneDeep, isEmpty, orderBy } from "lodash-es";
import { getTaskList } from "../../apis/tasks";
import { getTaskByType, getTaskLabel, taskDetail } from "../../utils/task";
import Icon from "../../components/Icon";
import NoticeIcon from "../../assets/images/icon/notice-icon.svg";
import Profile from "../../components/Profile";
import { toggleNotice } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";

const PannelBox = ({ pannel, actived, params }) => {
  return (
    <div
      className={classnames(`pannel-box`, {
        actived: actived,
      })}
    >
      <p className="pannel-label"> {pannel.pannelLabel} </p>
      <div
        className="pannel-item"
        style={{
          backgroundColor: actived
            ? convertHexToRGBA(getColor(pannel.count.color), 5)
            : "#ffffff",
        }}
        onClick={() => pannel.onClick(pannel, params)}
      >
        <p
          className={classnames(`count`, {
            [pannel.count.color]: pannel.count.value > 0,
          })}
        >

          {comma(pannel.count.value)}
        </p>
        <Badge color={pannel.badge.color}>{pannel.badge.label} </Badge>
      </div>
    </div>
  );
};

const ReminderBoard = () => {
  const [params, setParams] = useState({});
  const { taskToggle } = useSelector((store) => store.Task);
  const dispatch = useDispatch();
  const [taskField] = useState([
    {
      onValue: (data, field, datas) => {
        if (datas.cardType === "notice") {
          return (
            <div className="list-item" onClick={() => openNoticeDetail(datas)}>
              <span className="circle-icon">
                {datas && datas.topExposure === 1 &&
                  <label>[공지]</label>
                }
                <Icon src={NoticeIcon}> </Icon>
              </span>
              <p className="title"> {datas.title} </p>
              <p className="content"> {datas.summary} </p>
              <div className="date-profile">
                <p className="date"> {dateToViewFormat(datas.createdTime)} </p>
                <Profile employeeIdx={datas.writerEmpIdx} />
              </div>
            </div>
          );
        } else {
          // task
          const type = datas.type;
          const task = getTaskByType(type);
          return (
            <div className="list-item" onClick={() => openTaskDetail(datas)}>
              <span className="circle-icon">
                <Icon src={task.icon}> </Icon>
              </span>
              <p className="title">
                {task.label} {getTaskLabel(datas)}
              </p>
              <p className="content"> {datas.title} </p>
              <div className="date-profile">
                <p className="date"> {dateToViewFormat(datas.createdTime)} </p>
                <Profile data={datas.requesterEmployee} />
              </div>
            </div>
          );
        }
      },
    },
  ]);

  const [pannelList, setPannelList] = useState([
    {
      id: 1,
      type: "pannel",
      pannelLabel: "공지",
      count: {
        value: "-",
        color: "color-gray-7",
      },
      badge: {
        color: "secondary",
        label: "공지사항",
      },
      onClick: (pannel, params) => {
        if (pannel.id === params.id) {
          setParams({});
        } else {
          setParams(pannel);
        }
      },
    },
    {
      type: "vertical-line",
    },
    {
      id: 2,
      type: "pannel",
      pannelLabel: "내 할일",
      count: {
        value: "-",
        color: "color-purple-100",
      },
      badge: {
        color: "primary",
        label: "대기중",
      },
      onClick: (pannel, params) => {
        if (pannel.id === params.id) {
          setParams({});
        } else {
          setParams(pannel);
        }
      },
    },
    {
      type: "vertical-line",
    },
    {
      id: 3,
      type: "pannel",
      pannelLabel: "요청한 할일",
      count: {
        value: "-",
        color: "color-gray-7",
      },
      badge: {
        color: "secondary",
        label: "완료전",
      },
      onClick: (pannel, params) => {
        if (pannel.id === params.id) {
          setParams({});
        } else {
          setParams(pannel);
        }
      },
    },
    {
      type: "empty-line",
    },
    {
      id: 4,
      type: "pannel",
      pannelLabel: "",
      count: {
        value: "-",
        color: "color-red-100",
      },
      badge: {
        color: "danger",
        label: "반려됨",
      },
      onClick: (pannel, params) => {
        if (pannel.id === params.id) {
          setParams({});
        } else {
          setParams(pannel);
        }
      },
    },
    {
      type: "empty-line",
    },
    {
      id: 5,
      type: "pannel",
      pannelLabel: "",
      count: {
        value: "-",
        color: "color-green-100",
      },
      badge: {
        color: "success",
        label: "승인됨",
      },
      onClick: (pannel, params) => {
        if (pannel.id === params.id) {
          setParams({});
        } else {
          setParams(pannel);
        }
      },
    },
  ]);

  const openNoticeDetail = (data) => {
    dispatch(toggleNotice(data));
  };

  const openTaskDetail = (data, e) => {
    taskDetail(data);
  };

  const dateRange = [getDay(7), getDay()];

  const {
    setSubmit,
    // LIST 용
    filterSubmit,
    list,
    setList,
    isLoading,
    setIsLoading,
  } = useForm({
    order: [
      {
        createdTime: "desc",
      },
    ],
    dates: dateRange,
    page: 0,
    limit: 9999,
  });

  useEffect(() => {
    setSubmit(submit);
  }, []);

  useEffect(() => {
    filterSubmit();
  }, [taskToggle]);

  const submit = async ({ dates, ...params }) => {
    // 공지사항
    const getList1 = getNoticeList({
      range: {
        createdTime: {
          from: "2020-01-01",
          to: dates[1],
        },
      },
      ...getParams(params),
    });
    // 내가 할일
    const getList2 = getTaskList({
      approvalTargetStage: "pending",
      ownership: "owner",
      range: {
        createdTime: {
          from: dates[0],
          to: dates[1],
        },
      },
      ...getParams(params),
    });

    // 내가 요청한 할일 완료전
    const getList3 = getTaskList({
      approvalTargetStage: "incomplete",
      ownership: "requester",
      range: {
        createdTime: {
          from: dates[0],
          to: dates[1],
        },
      },
      ...getParams(params),
    });
    // 내가 요청한 할일 반려
    const getList4 = getTaskList({
      approvalTargetStage: "denied",
      ownership: "requester",
      range: {
        createdTime: {
          from: dates[0],
          to: dates[1],
        },
      },
      ...getParams(params),
    });
    // 내가 요청한 할일 승인
    const getList5 = getTaskList({
      approvalTargetStage: "approved",
      ownership: "requester",
      range: {
        createdTime: {
          from: dates[0],
          to: dates[1],
        },
      },
      ...getParams(params),
    });

    Promise.all([getList1, getList2, getList3, getList4, getList5])
      .then((datas) => {
        const _pannelList = cloneDeep(pannelList);
        _pannelList[0].count.value = datas[0].data.total || 0;
        _pannelList[2].count.value = datas[1].data.totalCount || 0;
        _pannelList[4].count.value = datas[2].data.totalCount || 0;
        _pannelList[6].count.value = datas[3].data.totalCount || 0;
        _pannelList[8].count.value = datas[4].data.totalCount || 0;
        const _list = [
          ...datas[0].data.posts.map((d) => {
            return {
              ...d,
              summary: d?.content?.replace(/<[^>]*>?/g, ''),
              filterId: 1,
              cardType: "notice",
            };
          }),
          ...datas[1].data.approvalTargetList.map((d) => ({
            ...d,
            filterId: 2,
            cardType: "task",
            topExposure: 0,
          })),
          ...datas[2].data.approvalTargetList.map((d) => ({
            ...d,
            filterId: 3,
            cardType: "task",
            topExposure: 0,
          })),
          ...datas[3].data.approvalTargetList.map((d) => ({
            ...d,
            filterId: 4,
            cardType: "task",
            topExposure: 0,
          })),
          ...datas[4].data.approvalTargetList.map((d) => ({
            ...d,
            filterId: 5,
            cardType: "task",
            topExposure: 0,
          })),
        ];
        //console.log(_list);
        setPannelList(_pannelList);
        setList(orderBy(_list, ["topExposure", "createdTime"], ["desc", "desc"]));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="reminder-board">
      <ColCard type="light">
        <div className="reminder-board-pannel">
          <span className="reminder-board-date-range">

            {dateToViewFormat(dateRange[0], "YY.MM.DD")}~
            {dateToViewFormat(dateRange[1], "YY.MM.DD")}
          </span>
          {pannelList.map((pannel, idx) => {
            switch (pannel.type) {
              case "vertical-line":
                return (
                  <div key={idx} className="pannel-box vertical-line">

                  </div>
                );
              case "empty-line":
                return (
                  <div key={idx} className="pannel-box empty-line">

                  </div>
                );
              default:
                return (
                  <PannelBox
                    key={idx}
                    pannel={pannel}
                    params={params}
                    actived={params.id === pannel.id}
                  />
                );
            }
          })}
        </div>
      </ColCard>
      <CardList
        // height={'80vh'}
        isTable={false}
        list={
          isEmpty(params)
            ? list
            : list.filter((item) => item.filterId === params.id)
        }
        fields={taskField}
        isLoading={isLoading}
      />
    </div>
  );
};

export default ReminderBoard;
